import creditCardBlank from './asda-credit-card-blank.svg'
import creditCardAddNew from './asda-credit-card-add-new.svg'
import creditCardAmex from './asda-credit-card-amex.svg'
import creditCardCirrus from './asda-credit-card-cirrus.svg'
import creditCardCvv from './asda-credit-card-cvv.svg'
import creditCardDiners from './asda-credit-card-diners.svg'
import creditCardDiscover from './asda-credit-card-discover.svg'
import creditCardMaestro from './asda-credit-card-maestro.svg'
import creditCardMasterCard from './asda-credit-card-mastercard.svg'
import creditCardPlus from './asda-credit-card-plus.svg'
import creditCardVisa from './asda-credit-card-visa.svg'

export default {
  'credit-card-blank': creditCardBlank,
  'credit-card-add-new': creditCardAddNew,
  'credit-card-amex': creditCardAmex,
  'credit-card-cirrus': creditCardCirrus,
  'credit-card-cvv': creditCardCvv,
  'credit-card-diners': creditCardDiners,
  'credit-card-discover': creditCardDiscover,
  'credit-card-maestro': creditCardMaestro,
  'credit-card-master-card': creditCardMasterCard,
  'credit-card-plus': creditCardPlus,
  'credit-card-visa': creditCardVisa,
}



// WEBPACK FOOTER //
// ./common/components/icon/credit-cards/index.js